<template>
  <div class="drop" @dragover.prevent @drop="onDrop">
    <label class="btn display-inline">
      PRZECIĄGNIJ I UPUŚĆ LUB
      <input
        type="file"
        name="value"
        ref="fileInput"
        @change="onChange"
        accept="video/*"
      />
    </label>
  </div>
</template>

<script>
export default {
  methods: {
    onDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      let files = e.dataTransfer.files
      if (files[0] && files[0].type.startsWith('video/')) {
        this.$emit('submit', files[0])
      } else {
        this.$message({
          message: 'Proszę wybrać plik wideo',
          type: 'error'
        })
      }
    },
    onChange(e) {
      let files = e.target.files
      if (files[0] && files[0].type.startsWith('video/')) {
        this.$emit('submit', files[0])
      } else {
        this.$message({
          message: 'Proszę wybrać plik wideo',
          type: 'error'
        })
      }
    },
    clear() {
      this.$refs.fileInput.value = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.drop {
  border: 2px dashed #ccc;
  padding: 40px;
  background-color: #fafafa;
  height: 100%;
  position: relative;
  max-width: 100%;
  text-align: center;
  margin: 0 auto;
}

.drop video {
  max-width: 100%;
}
</style>
